import React, { forwardRef, useMemo } from 'react';
import {
  FormSelectTrigger,
  Size,
} from 'shared/components/ui/form-select-trigger';
import { TagSearchMenu } from 'shared/components/ui/tag-search-menu';
import { useForwardedRef } from 'shared/hooks/use-forwarded-ref';
import { useOpenMenu } from 'shared/hooks/use-open-menu';
import { ID } from 'shared/types/id';
import { Tag as TagType } from 'shared/types/tag';

import * as Styled from './form-tags-search.style';

export type FormTagsSearchProps = {
  tags: TagType[];
  value?: ID[] | null;
  onChange: (ids: ID[]) => void;
  placeholder?: string;
};

export const FormTagsSearch = forwardRef<HTMLDivElement, FormTagsSearchProps>(
  ({ tags, value, onChange, placeholder }, ref) => {
    const containerRef = useForwardedRef<HTMLDivElement>(ref);

    const { menuOpen, openMenu, closeMenu } = useOpenMenu();

    const onClear = (e: React.MouseEvent) => {
      e.preventDefault();
      onChange([]);
      closeMenu();
    };

    const selectedTags = useMemo(
      () => tags.filter(({ id }) => value?.includes(id)),
      [tags, value],
    );

    return (
      <Styled.InputContainer ref={containerRef}>
        <FormSelectTrigger
          onClick={openMenu}
          isPlaceholder={!value?.length}
          size={Size.ExtraSmall}
          noOverflow
          onClear={value?.length ? onClear : undefined}
        >
          {selectedTags.length
            ? selectedTags.map(({ name }) => name).join(', ')
            : placeholder}
        </FormSelectTrigger>

        {menuOpen && (
          <TagSearchMenu
            tags={tags}
            onChange={onChange}
            value={value}
            referenceElement={containerRef}
            position="bottom"
            onOutside={closeMenu}
          />
        )}
      </Styled.InputContainer>
    );
  },
);
